import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_SAVE_NEW_ACTION_BEGIN,
  EVENTS_SAVE_NEW_ACTION_SUCCESS,
  EVENTS_SAVE_NEW_ACTION_FAILURE,
  EVENTS_SAVE_NEW_ACTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function saveNewAction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_SAVE_NEW_ACTION_BEGIN,
    });
    const { projectId, version, eventId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}/actions`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_SAVE_NEW_ACTION_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Added new action in event');
          toast.success('Created Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_SAVE_NEW_ACTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to add new action in event');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Creation Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveNewActionError() {
  return {
    type: EVENTS_SAVE_NEW_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_SAVE_NEW_ACTION_BEGIN:
      return {
        ...state,
        saveNewActionPending: true,
        saveNewActionError: null,
      };

    case EVENTS_SAVE_NEW_ACTION_SUCCESS:
      const currentActions = state.selectedEvent.actions || [];
      currentActions.push(action.data);
      return {
        ...state,
        saveNewActionPending: false,
        isOpenActionEnableModal: false,
        saveNewActionError: null,
        selectedAction: action.data,
        selectedEvent: {
          ...state.selectedEvent,
          actions: currentActions,
        },
      };

    case EVENTS_SAVE_NEW_ACTION_FAILURE:
      return {
        ...state,
        saveNewActionPending: false,
        saveNewActionError: action.data.error,
      };

    case EVENTS_SAVE_NEW_ACTION_DISMISS_ERROR:
      return {
        ...state,
        saveNewActionError: null,
      };

    default:
      return state;
  }
}
